import { render, staticRenderFns } from "./HrDocument.vue?vue&type=template&id=a9b5ca5c&scoped=true&"
import script from "./HrDocument.vue?vue&type=script&lang=js&"
export * from "./HrDocument.vue?vue&type=script&lang=js&"
import style0 from "./HrDocument.vue?vue&type=style&index=0&id=a9b5ca5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b5ca5c",
  null
  
)

export default component.exports